import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import rootReducer from "../reducers";
export default function configureStore() {
    return createStore(rootReducer, applyMiddleware(thunk));
}



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/store/configureStore.ts
// module id = TmcO
// module chunks = 2